import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FtoReportSimilarService } from '../similar-service';
import { FtoReportSimilarRepository } from '../../repositories/similar-repository';
import type { PatentProfileWithMatchedTechFeature } from '../../types';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

@injectable()
export class FtoReportSimilarServiceImpl implements FtoReportSimilarService {
    constructor(
        @inject(FtoReportSimilarRepository)
        private readonly _noveltySimilarRepository: FtoReportSimilarRepository,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) { }

    async updateNoveltySimilarList(techFeatures: PatentProfileWithMatchedTechFeature[]): Promise<PatentProfileWithMatchedTechFeature[]> {
        return this._noveltySimilarRepository.updateNoveltySimilarList(this._currentTaskService.taskId, techFeatures);
    }

    async getFeatureComparison(pns: string[]): Promise<PatentProfileWithMatchedTechFeature[]> {
        return this._noveltySimilarRepository.getFeatureComparison(this._currentTaskService.taskId, pns);
    }
}
